import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { accountService } from '../../services/AccountService';

export default {
    name: 'ForgotPassword',
    data: () => {
        return {
            loading: true,
            errors: '',
            emailAddress: '',
            emailSent: false,
        }
    },
    validations: {
        emailAddress: {
            required,
            minLength: minLength(6)
        }
    },
    computed: {
        isValid() {
            return !this.$v.$anyError
        }
    },
    created() {
        var model = this;

        model.loading = false;
    },
    methods: {
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        handleSubmit() {
            var model = this;

            if (!model.validate())
                return;

            accountService.forgotPassword(model.emailAddress)

                .finally(() => this.loading = false)
                .then(response => {
                    model.emailSent = true;
                })
                .catch(e => {
                    showErrorNotification(e);
                });
        }
    }
}
